import { render, staticRenderFns } from "./ViewAnalyticsBudget.vue?vue&type=template&id=35bf7a40&scoped=true&"
import script from "./ViewAnalyticsBudget.vue?vue&type=script&lang=js&"
export * from "./ViewAnalyticsBudget.vue?vue&type=script&lang=js&"
import style0 from "./ViewAnalyticsBudget.vue?vue&type=style&index=0&id=35bf7a40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bf7a40",
  null
  
)

export default component.exports